import { defineStore } from "pinia";
import RvApi from "../rvapi";
import type { Frame, UploadFrame } from "@/types/frames";
import { v4 as uuidv4 } from "uuid";
import type { NotificationObj } from "@/types/common";

export const useFrames = defineStore("frames", {
  state: (): {
    allFrames: Frame[];
    framesForGroup: Frame[];
    notification: NotificationObj;
  } => ({
    allFrames: [],
    framesForGroup: [],
    notification: {
      show: false,
      message: "",
      type: "error",
      autoHide: false,
    },
  }),
  getters: {
    framesGroupedByGroupId: (state) =>
      state.allFrames.reduce<Record<string, Frame[]>>((acc, frame) => {
        const key = String(frame.groupId);
        acc[key] ??= [];
        acc[key].push(frame);
        return acc;
      }, {}),
  },
  actions: {
    async getAllFrames() {
      try {
        this.allFrames = (await RvApi.getFrames()).frames;
      } catch (e: any) {
        console.log("error in getting frames " + e);
        throw e;
      }
    },
    normalizeGroupIds() {
      this.allFrames = this.allFrames.map((frame) => ({
        ...frame,
        groupId: frame.groupId ?? uuidv4(),
        isValid: frame.groupId !== undefined,
      }));
    },
    async getFramesByGroupId(groupId: string) {
      this.framesForGroup = (await RvApi.getFramesByGroupId(groupId)).frames;
    },
    setNotificationAlert({
      show = false,
      message = "",
      type = "error",
      autoHide = true,
    }: NotificationObj) {
      this.notification.show = show;
      this.notification.message = message;
      this.notification.type = type;
      this.notification.autoHide = autoHide;
      if (show && autoHide) {
        setTimeout(() => {
          this.notification.show = false;
        }, 5000); // notification delay to be configured as a config later on
      }
    },
    async getFrame(frameId: string) {
      return RvApi.getFrame(frameId);
    },
    updateFrame(frameId: string, uploadObj: UploadFrame) {
      return RvApi.saveFrame(frameId, uploadObj);
    },
    deleteFrame(frameId: number) {
      return RvApi.deleteFrame(frameId);
    },
    async reorderFrames(frameIds: number[]) {
      await RvApi.reorderFrames(frameIds);
    },
  },
});
